// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "img[data-v-3c26dc72]{max-width:100%;-o-object-fit:contain;object-fit:contain}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){img[data-v-3c26dc72]{height:auto!important}}@media screen and (max-width:431px){.partner-sponsors__divider[data-v-3c26dc72]{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
